/**
 * Microsoft Entra ID (Azure AD) MSAL Configuration
 */

import { Configuration, LogLevel, PopupRequest, RedirectRequest } from '@azure/msal-browser';

const TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || '';
const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const REDIRECT_URI = process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin;

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: REDIRECT_URI,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'sessionStorage',  // Use sessionStorage for intranet security
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (process.env.NODE_ENV === 'development') {
          console.log(`[MSAL] ${message}`);
        }
      },
      logLevel: process.env.NODE_ENV === 'development' ? LogLevel.Info : LogLevel.Warning
    }
  }
};

// Scopes for Entra ID token - reads user profile
export const loginRequest: PopupRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    `api://${CLIENT_ID}/COMP.Access`  // Custom API scope - register in Entra ID
  ]
};

// Separate Graph-scoped request — different audience from the COMP API token
export const graphRequest = {
  scopes: ['https://graph.microsoft.com/User.Read']
};

export const silentRequest = {
  scopes: loginRequest.scopes,
  forceRefresh: false
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};
